/** WebSocket client for live dispatch updates. Token is required by backend. */
import { BACKEND_URL } from "@/lib/api";

export function openDispatchSocket(onMessage) {
    const wsProto = BACKEND_URL.startsWith("https") ? "wss" : "ws";
    const token = localStorage.getItem("rd_token") || "";
    const wsUrl = `${wsProto}://${BACKEND_URL.replace(/^https?:\/\//, "")}/api/ws/dispatch${token ? `?token=${encodeURIComponent(token)}` : ""}`;
    let socket;
    let keepAlive;
    let closed = false;

    const connect = () => {
        try {
            socket = new WebSocket(wsUrl);
            socket.onopen = () => {
                keepAlive = setInterval(() => {
                    try { socket.send("ping"); } catch {}
                }, 25000);
            };
            socket.onmessage = (e) => {
                try { onMessage(JSON.parse(e.data)); } catch {}
            };
            socket.onclose = () => {
                clearInterval(keepAlive);
                if (!closed) setTimeout(connect, 3000); // reconnect
            };
            socket.onerror = () => {
                try { socket.close(); } catch {}
            };
        } catch {
            setTimeout(connect, 3000);
        }
    };
    connect();

    return () => {
        closed = true;
        clearInterval(keepAlive);
        if (socket) try { socket.close(); } catch {}
    };
}
